import { ProductApiDto, SkuApiDto } from '@b2x/storefront-api-js-client/src/dto';
import React from 'react';

import { Button, ButtonProps } from './Button';
import { appConfig } from './config';
import { AddToCartFieldsHelper } from './form/AddToCartForm';
import { Div } from './HTMLElement';
import { t } from './i18n/i18n';

export interface AddToCartFormButtonProps<ButtonVariant, IconName, IconSize> {
  availabilityEmailNotificationButton?: ButtonProps<ButtonVariant, IconName, IconSize>;
  fieldsHelper?: AddToCartFieldsHelper;
  product?: ProductApiDto;
  selectedSku?: SkuApiDto;
  submitButton?: ButtonProps<ButtonVariant, IconName, IconSize>;
}

export const AddToCartFormButton = <ButtonVariant extends string, IconName extends string, IconSize extends number>({
  availabilityEmailNotificationButton,
  fieldsHelper,
  product,
  selectedSku,
  submitButton,
}: AddToCartFormButtonProps<ButtonVariant, IconName, IconSize>) => {
  const { skusNotAvailable } = appConfig;

  const iconStartProps = appConfig.icons?.email ? { name: appConfig.icons.email } : undefined;

  return (
    <React.Fragment>
      {skusNotAvailable === 'ADD-TO-WISHLIST' || skusNotAvailable === 'OUT-OF-STOCK' ? (
        <>
          {selectedSku?.state === undefined || selectedSku.state === 'AVAILABLE' ? (
            <>
              <Button
                aria-label={t('accessibility.form.addToCartForm.buttons.submit.label')}
                {...fieldsHelper?.buttons.submit}
                variant={selectedSku?.state === undefined ? 'outline-primary' : 'primary'}
                {...submitButton}
              />
            </>
          ) : skusNotAvailable === 'ADD-TO-WISHLIST' ? (
            <Button
              aria-label={t('accessibility.form.addToCartForm.buttons.availabilityEmailNotification.addLong.label', {
                productName: `${product?.name} ${selectedSku.name}`,
              })}
              {...fieldsHelper?.buttons.availabilityEmailNotification}
              iconStart={iconStartProps}
              variant="outline-primary"
              {...availabilityEmailNotificationButton}
            />
          ) : (
            <Div display={{ lg: 'flex', xs: 'grid' }} justifyContent={{ lg: 'end' }}>
              <Button className="" disabled label={t('misc.productNotAvailable')} variant="outline-primary" />
            </Div>
          )}
        </>
      ) : (
        <Button
          aria-label={t('accessibility.form.addToCartForm.buttons.submit.label', {
            productName: `${product?.name} ${selectedSku?.name}`,
          })}
          {...fieldsHelper?.buttons.submit}
          {...submitButton}
        />
      )}
    </React.Fragment>
  );
};
